<h1 mat-dialog-title tabIndex="0">
    {{data.title | translate}}
    <i class="dolineo-icon dolineo-icon-close dolineo-icon-gray"
       matTooltip="{{'Common.Close' | translate}}"
       matTooltipPosition="below"
       matTooltipClass='below-top'
       (click)="dialogRef.close()"></i>
</h1>

<div mat-dialog-content>
    <div class="date-form-preview">
        <p class="date-form-preview--content" [innerHTML]="data.content | translate"></p>
        <p class="date-form-preview--description" [innerHTML]="data.description | translate"></p>

        <div class="date-form-preview--training">
            <span class="date-form-preview--training--desc">{{'Common.training' | translate}}: </span>
            <span class="date-form-preview--training--name">{{ data.training.name }}</span>
        </div>

        <div class="date-form-preview--section">
            <i><img src="assets/icons/on-site-training-date.svg"/></i>
            <div class="date-form-preview--section--value">{{ moment(data.date.startDate).format('DD.MM.YYYY, HH:mm') + ' - ' +  moment(data.date.endDate).format('DD.MM.YYYY, HH:mm') }}</div>
        </div>
        <div class="date-form-preview--section">
            <i><img src="assets/icons/on-site-training-place.svg"/></i>
            <div class="date-form-preview--section--value">{{ data.date.place }}</div>
        </div>
    </div>
</div>

<div mat-dialog-actions class="dialog-footer">
    <button (click)="dialogRef.close(false)" mat-button
            class="cancel-button">{{(data.cancelText || 'Common.Cancel') | translate}}</button>
    <button mat-button color="primary" (click)="dialogRef.close(true)"
            class="dolineo-button blue-button">{{(data.okText || 'Ok') | translate}}</button>
</div>